export default __webpack_public_path__ + "static/media/garden_1.913841fa.jpg";